import { useEffect } from "react";

function upsertMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  if (!href) return;
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Lightweight per-page SEO: sets document title, meta description and a
 * canonical link. Restores the site's default title on unmount and removes
 * the canonical tag so it doesn't leak onto other routes.
 */
export default function useSeo(title, description, canonical) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    if (description) upsertMeta("description", description);
    if (canonical) upsertCanonical(canonical);
    return () => {
      document.title = prevTitle;
      const el = document.querySelector('link[rel="canonical"]');
      if (el) el.remove();
    };
  }, [title, description, canonical]);
}
